<!-- DEVICES LIST: TITLE + ACTION + SELECTOR -->

<!-- MOBILE -->
<div *ngIf="onExtendedMobile()" class="grid mx-0 flex align-items-center">
	<div class="col-1"></div>
	<div class="col-10 flex justify-content-center text-xl font-bold">
		{{ 'DEVICES' | translate }}
	</div>
	<div class="col-1 flex justify-content-end">
		<app-site-button-bar></app-site-button-bar>
	</div>
	<div class="col-12">
		<app-site-selector></app-site-selector>
	</div>
</div>
<!-- DESKTOP && TABLET-->
<div *ngIf="!onExtendedMobile()" class="layout-content p-0" [ngClass]="layoutMarginResponsive()">
	<div class="grid flex align-items-center justify-content-between">
		<app-site-selector class="col-9"></app-site-selector>
		<app-site-button-bar class="col-3"></app-site-button-bar>
	</div>
</div>

<!-- DEVICE TREETABLE FOR EVERYONE -->
<div class="grid m-0">
	<div class="col-12">
		<app-device-category-tab-group></app-device-category-tab-group>
	</div>
</div>